<template>
  <div class="layout-img">
    <b-container>
      <little-bar
        :navlist="navlist"
        copyright="forum"
        @changeCurrent="changeCurrent"
      >
      </little-bar>
      <div class="list">
        <b-row>
          <template v-for="(item, index) in dataList">
            <b-col :key="index" md="4" cols="6" class="block">
              <router-link
                :to="`/forum/project/citySummit/selDedail?id=${item.id}`"
              >
                <div class="img-wrap img-hovor">
                  <img width="100%" height="100%" :src="item.titleImg" />
                </div>
                <div class="title">
                  <p>
                    {{ item.title }}
                  </p>
                </div>
              </router-link>
            </b-col>
          </template>
        </b-row>
      </div>
    </b-container>
  </div>
</template>
<script>
import littleBar from "@/forumcomponents/littleBar";

export default {
  data() {
    return {
      firId: "",
      secId: "",
      navlist: [
        {
          text: "ALL",
          link: "/forum/project/citySummit/list",
        },
      ],
      dateDrop: [],
      dataList: [],
    };
  },
  components: {
    littleBar,
  },
  mounted() {},
  watch: {
    $route: {
      handler(to) {
        this.firId = to.query.firId;
        this.secId = to.query.secId;
        this.getList();
      },
      immediate: true,
      deep: true,
    },
  },
  created() {
    this.geyNav();
  },
  methods: {
    changeCurrent(index, path) {
      this.$router.push({
        path: path,
        query: {
          index: index,
        },
      });
    },
    geyNav() {
      this.$forumApi
        .getSecNavList({
          parentId: this.firId,
        })
        .then((res) => {
          res.data.forEach((item) => {
            this.navlist.push({
              text: item.name,
              firId: item.parentId,
              secId: item.id,
              path: `/forum/project/citySummit/list?firId=${item.parentId}&secId=${item.id}`,
            });
          });
        });
    },
    getList() {
      this.$forumApi
        .getSecList({
          categoryId: this.firId,
          categorySecId: this.secId,
        })
        .then((res) => {
          this.dataList = res.data;
          console.log("getSecList", res.data);
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.layout-img ::v-deep {
  margin-top: 1rem;

  .img-wrap {
    width: 100%;
    height: 16.5rem;
    margin: 1rem auto;

    img:hover {
      transform: scale(1.05, 1.05);
      transition: transform 0.8s cubic-bezier(0.215, 0.61, 0.355, 1),
        opacity 0.36s cubic-bezier(0.215, 0.61, 0.355, 1);
    }
  }
  .title {
    width: 90%;
    margin: auto 1rem;
  }
  a {
    text-decoration: none;
    cursor: pointer;
    color: #4a4a4a;
  }

  p {
    margin-top: 0.5rem;
    color: #4a4a4a;
    margin-left: 0.5rem;
    font-size: 15px;
    font-family: Arial, "Microsoft YaHei";
  }
  .list {
    min-height: 30rem;
  }
  .title {
    font-size: 1.5rem;
  }

  .row {
    margin-right: 0px;
    margin-left: 0px;
  }
}

@media (max-width: 768px) {
  .block {
    display: flex;
  }
  .layout-img ::v-deep {
    .img-wrap {
      width: 90%;
      height: 50%;
      border-radius: 6px;
      overflow: hidden;
      margin-bottom: unset;
    }
    .title {
      width: 90%;
      margin: unset;
      color: #4a4a4a;
      transform: scale(0.8);
    }

    .col-md-4,
    .col-7 {
      padding-right: 0.1rem;
      padding-left: 0.1rem;
    }

    .row {
      flex-wrap: wrap;
    }
  }
}
</style>
